function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect } from "react";
import cn from "classnames";
import { isAfter } from "date-fns";
import { noop } from "../../lib/utils";
import { TimeTypes } from "../../models/DateTime";
import DateTimeTitle from "./DateTimeTitle";
import Button from "../ui/Button";
import DatePicker from "./DatePicker";
import TimeInput from "../ui/TimeInput";
import CloseIcon from "../../images/Close";
import "../../styles/date/modal-date-picker.scss";
export default function ModalDatePicker({
  className,
  datePickerClassName,
  dateTime,
  isReturn,
  isSeason,
  isOther,
  onClose = noop,
  onSave = noop,
  maxDate,
  minDate,
  disableTimePicker = false
}) {
  const _React$useState = React.useState(dateTime.clone()),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        selectedDateTime = _React$useState2[0],
        setSelectedDateTime = _React$useState2[1];

  const handleSave = () => {
    onSave(selectedDateTime);
    onClose();
  };

  const handleClose = () => {
    onClose();
  };

  const handleDate = date => {
    setSelectedDateTime(selectedDateTime.produce({
      date
    }));
  };

  const handleTime = time => {
    if (time === TimeTypes.DEPART_NOW) {
      setSelectedDateTime(selectedDateTime.produce({
        timeType: TimeTypes.DEPART_NOW
      }));
    } else {
      setSelectedDateTime(selectedDateTime.produce({
        time
      }));
    }
  };

  const handleTimeType = timeType => {
    setSelectedDateTime(selectedDateTime.produce({
      timeType
    }));
  };

  const isDateInPast = isAfter(new Date(), selectedDateTime.toDate());
  useEffect(() => {
    if (isDateInPast) {
      setSelectedDateTime(selectedDateTime.produce({
        timeType: TimeTypes.DEPART_NOW
      }));
    }
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: cn("otrl-ui__modal-date-picker", className)
  }, /*#__PURE__*/React.createElement("div", {
    className: "otrl-ui__modal-date-picker__header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "otrl-ui__modal-date-picker__header__bar",
    onClick: handleClose
  }, /*#__PURE__*/React.createElement("div", {
    className: "otrl-ui__modal-date-picker__header__title-wrapper"
  }, /*#__PURE__*/React.createElement(DateTimeTitle, {
    dateTime: selectedDateTime,
    isReturn: isReturn,
    isSeason: isSeason,
    isOther: isOther,
    disableTimePicker: disableTimePicker
  })), /*#__PURE__*/React.createElement("button", {
    className: "otrl-ui__modal-date-picker__close",
    "aria-label": "Close"
  }, /*#__PURE__*/React.createElement(CloseIcon, null)))), /*#__PURE__*/React.createElement("div", {
    className: "otrl-ui__modal-date-picker__datetime-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "otrl-ui__modal-date-picker__wrapper"
  }, /*#__PURE__*/React.createElement(DatePicker, {
    formatTitle: "MMMM",
    onChange: handleDate,
    selected: selectedDateTime.toDate(),
    maxDate: maxDate,
    minDate: minDate,
    className: datePickerClassName
  })), !disableTimePicker && !isSeason && !isOther && /*#__PURE__*/React.createElement(TimeInput, {
    dateTime: selectedDateTime,
    onTimeChange: handleTime,
    onTimeTypeChange: handleTimeType,
    isReturn: isReturn
  })), /*#__PURE__*/React.createElement(Button, {
    className: "otrl-ui__button--full-width",
    disabled: isDateInPast,
    text: "Done",
    onClick: handleSave
  }));
}